var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0767 3.21993C28.4183 2.39864 29.5817 2.39864 29.9233 3.21993L36.436 18.8784C36.58 19.2246 36.9056 19.4612 37.2794 19.4911L54.184 20.8464C55.0707 20.9175 55.4302 22.024 54.7547 22.6026L41.8752 33.6353C41.5904 33.8793 41.466 34.262 41.553 34.6268L45.4879 51.1228C45.6943 51.988 44.753 52.6719 43.9939 52.2082L29.5213 43.3684C29.2012 43.1729 28.7988 43.1729 28.4787 43.3684L14.006 52.2082C13.247 52.6719 12.3057 51.988 12.5121 51.1228L16.447 34.6268C16.534 34.262 16.4096 33.8793 16.1248 33.6353L3.24532 22.6026C2.56978 22.024 2.92931 20.9175 3.81596 20.8464L20.7206 19.4911C21.0944 19.4612 21.42 19.2246 21.564 18.8784L28.0767 3.21993Z",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b45106fe.svg";
export { ForwardRef as ReactComponent };